/**
 * The backend's AI credit units in one credit as the app shows it: the API divides the balance
 * by the same number (AiHelper.NotificationNumberDivider) for the dashboard and Settings > AI.
 */
export const DISPLAY_CREDIT_UNITS = 10000;

// Credits are shown scaled down from the backend balance.
export const displayCredits = (credits: number) =>
  Math.floor(credits / DISPLAY_CREDIT_UNITS);
